define([
	"dojo/_base/declare",
	"./String",
	"./_LocalizedMixin"
], function(declare,StringRen,_LocalizedMixin) {

	return declare([StringRen,_LocalizedMixin], {
	});
});